import { render, staticRenderFns } from "./pageTreeViewComponent.vue?vue&type=template&id=52b12a20&"
import script from "./pageTreeViewComponent.vue?vue&type=script&lang=js&"
export * from "./pageTreeViewComponent.vue?vue&type=script&lang=js&"
import style0 from "./pageTreeViewComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports